import {Component, Input} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {ReportExportFormat, ReportType} from '../../../../../../types/enums/report.enum';
import {TranslateSafePipe} from '../../../../../../shared/pipes/translation.pipe';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-report-download',
  imports: [
    TranslateSafePipe
  ],
  templateUrl: './report-download.html',
  styleUrl: './report-download.css',
})
export class ReportDownloadStep {
  @Input({required: true}) formGroup!: FormGroup;

  constructor(
    private readonly _translateService: TranslateService,
  ) {
  }

  public get reportType(): ReportType | undefined {
    return this.formGroup?.value?.['reportType'];
  }

  public get reportFormat(): ReportExportFormat | undefined {
    return this.formGroup?.value?.['format'];
  }

  public get hasReportTime(): boolean {
    return true
  }

  public get dateFrom(): string {
    let from: string | undefined = this.formGroup?.value?.['dateFrom'];
    if (!from) return this._translateService.instant('common.label.beginning');

    let fromDate: Date = new Date(from);
    // 11.08.2026 10:09
    return Intl.DateTimeFormat('de-DE', {dateStyle: 'short', timeStyle: 'short'}).format(fromDate);
  }

  public get dateTo(): string | undefined {
    let to: string | undefined = this.formGroup?.value?.['dateTo'];
    if (!to) return this._translateService.instant('common.label.today');

    let toDate: Date = new Date(to);

    return Intl.DateTimeFormat('de-DE', {dateStyle: 'short', timeStyle: 'short'}).format(toDate);
  }
}
